import styled from 'styled-components'
import {Link} from 'react-router-dom'

export const NewsHotBoxWrap = styled.div`
    margin-top: 10px;
    position: ${({sticky}) => sticky ? 'sticky': ''};
    top: 0;
    padding: 5px 0;

    @media screen and (max-width: 767px) {
        margin-top: 0;
        position: unset;
    }
`

export const NewsHotList = styled.ul`
    width: 100%;
    list-style: none;

    @media screen and (min-width: 768px) and (max-width: 1023px) {
        margin-top: 6px;
    }

    @media screen and (max-width: 767px) {
        margin-top: 5px;
    }
`

export const NewsHotItem  = styled.li`
    width: 100%;
    border-top: 1px dotted #bdbdbd;
    padding: 10px 0;
    display: flex;
`

export const NewsHotImageLink = styled(Link)`
    text-decoration: none;
    align-self: flex-start;
    position: relative;
`

export const Number = styled.span`
    color: #fff;
    font-size: 16px;
    font-weight: bold;
    background-color: #e32;
    position: absolute;
    left: 0;
    top: 0;
    width: 24px;
    height: 24px;
    text-align: center;
    line-height: 26px;

    @media screen and (min-width: 768px) and (max-width: 1023px) {
        width: 20px;
        height: 20px;
        font-size: 13px;
        line-height: 20px;
    }
`

export const NewsHotImage = styled.img`
    width: 120px;
    height: 75px;

    @media screen and (min-width: 768px) and (max-width: 1023px) {
        width: 56px;
        height: 40px;
    }

    @media screen and (max-width: 767px) {
        width: 165px;
        height: 103px;
    }

    @media screen and (max-width: 374px) {
        width: 128px;
        height: 80px;
    }
`

export const NewsHotBody = styled.div`
    margin-left: 12px;
`

export const NewsHotTitle = styled(Link)`
    text-decoration: none;
    color: #222;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.38;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    display: -webkit-box;

    @media screen and (min-width: 768px) and (max-width: 1023px) {
        font-size: 12px;
        line-height:  1.2;
    }

    @media screen and (max-width: 767px) {
        font-size: 18px;
        -webkit-line-clamp: 4;
    }

    @media screen and (max-width: 374px) {
        font-size: 15px;
        -webkit-line-clamp: 4;
    }
`

export const NewsHotDate = styled.span`
    color: #9b9b9b;
    font-size: 11px;
    
`